import axios from "axios";
// Entities
import { Blocking, BlockingsFields } from "@/entities/index";

export async function getBlockages({
  client,
  integrateStepZero,
  userId,
  blockingsFields,
}: {
  client: string;
  integrateStepZero: boolean;
  userId: number;
  blockingsFields: BlockingsFields;
}): Promise<Blocking[]> {
  const blockings = (
    await axios.post(`/api/blockages`, {
      client,
      integrateStepZero,
      reference: blockingsFields.reference,
      warehouse: blockingsFields.warehouse,
      lot: blockingsFields.lot,
      cause: blockingsFields.cause,
    })
  ).data as Blocking[];
  await axios.post("/api/stats/action", {
    userId,
    action: "Recherche des blocages",
  });

  return blockings;
}
